/* eslint-disable react/button-has-type */
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import IconSet from '../mdt-iconset/index.js';

import './button.css';

export const MDTButton = ({
    type,
    dataTest = 'button',
    onClick,
    disabled,
    name,
    label,
    faceIcon,
    faceIconClass,
    className,
    customStyle,
    iconPosition,
    htmlFor,
    btnRef,
    size,
    wrapperClass,
    ...rest
}) => {
    const isButton = type !== 'label';

    // This probably needs refactor long term.
    return (
        <div
            className={classNames(wrapperClass, {
                'mdt-button': true,
                'd-block': size === 'fullWidth',
            })}
        >
            {isButton && (
                <button
                    data-test={dataTest}
                    type={type}
                    className={classNames(className, size && `btn-${size}`)}
                    onClick={onClick}
                    disabled={disabled}
                    name={name}
                    title={label}
                    style={customStyle}
                    ref={btnRef}
                    {...rest}
                >
                    {iconPosition === 'left' && faceIcon && (
                        <IconSet name={faceIconClass} icon={faceIconClass} />
                    )}
                    {label}
                    {iconPosition === 'right' && faceIcon && (
                        <IconSet name={faceIconClass} icon={faceIconClass} />
                    )}
                </button>
            )}
            {!isButton && (
                <label
                    disabled={disabled}
                    data-test={dataTest}
                    className={className}
                    htmlFor={htmlFor}
                >
                    {label}
                </label>
            )}
        </div>
    );
};

MDTButton.propTypes = {
    type: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    label: PropTypes.string,
    htmlFor: PropTypes.string,
    faceIcon: PropTypes.bool,
    faceIconClass: PropTypes.string,
    className: PropTypes.string,
    iconPosition: PropTypes.string,
    wrapperClass: PropTypes.string,
    size: PropTypes.oneOfType([
        PropTypes.oneOf(['small', 'medium', 'large', 'fullWidth']),
        PropTypes.string,
    ]),
};

MDTButton.defaultProps = {
    type: 'button',
    onClick: () => {},
    disabled: false,
    name: 'MDTButton',
    label: '',
    htmlFor: 'MDTButton',
    faceIcon: false,
    faceIconClass: '',
    className: 'secondary',
    iconPosition: 'left',
    size: '',
    wrapperClass: '',
};

export default MDTButton;
